/**
 * Check if stars and text should be reduced based on screen size
 * @param {boolean} isSmallScreen
 * @param {boolean} isRelatedProduct
 * @param {boolean} renderLikesAndSuperLikes
 * @returns {boolean}
 */
const shouldReduceStarsAndTextBasedOnScreenSizeUtil = (isSmallScreen, isRelatedProduct, renderLikesAndSuperLikes) =>
  (isSmallScreen || isRelatedProduct) && renderLikesAndSuperLikes

export default shouldReduceStarsAndTextBasedOnScreenSizeUtil
